// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditions":"termsAndConditions__5Fwi_","contentContainer":"contentContainer__1LLRe","longTitle":"longTitle__2nxid","shortTitle":"shortTitle__2he00"};